import { useState } from 'react'
import { DateTime } from 'luxon'
import Select from 'components/Inputs/Select'
import ItemTabs from 'components/ItemTabs'
import TimeWindow from 'services/timeWindow'
import Payables from './Payables'
import BankAccounts from './BankAccounts'
import Cash from './Cash'
import Receivables from './Receivables'
import Goals from './Goals'
import { Container, FilterContainer } from './styles'

const VIEW_TABS = [
  { label: 'Recebíveis', value: 'receivables' },
  { label: 'Dinheiro', value: 'cash' },
  { label: 'Contas bancárias', value: 'bank_accounts' },
  { label: 'Metas', value: 'goals' },
  { label: 'A pagar', value: 'payables' }
]

// Abas que olham um mês específico; as demais ignoram o seletor de mês.
const MONTHLY_VIEWS = ['receivables', 'cash', 'goals']

const MONTH_OPTIONS = Array.from({ length: 12 }, (_, index) => {
  const label = DateTime.local(2000, index + 1, 1).setLocale('pt-BR').toFormat('LLLL')

  return { label: label.charAt(0).toUpperCase() + label.slice(1), value: index + 1 }
})

export default function CashFlow() {
  const now = DateTime.now().setLocale('pt-BR')
  const [year, setYear] = useState({ label: now.toFormat('yyyy'), value: now.year })
  const [month, setMonth] = useState(MONTH_OPTIONS[now.month - 1])
  const [view, setView] = useState('receivables')

  return (
    <Container style={{gap: 0}}>
      <FilterContainer wide={MONTHLY_VIEWS.includes(view)}>
        {MONTHLY_VIEWS.includes(view) && (
          <Select
            name='month'
            placeholder='Mês...'
            value={month}
            options={MONTH_OPTIONS}
            onChange={(_, option) => setMonth(option)}
          />
        )}
        <Select
          name='year'
          placeholder='Ano...'
          value={year}
          options={TimeWindow.getYears('2021', now.year.toString())}
          onChange={(_, option) => setYear(option)}
        />
      </FilterContainer>
      <ItemTabs
        tabs={VIEW_TABS}
        selectedTab={view}
        tabWidth={150}
        onTabChange={setView}
        containerStyle={{marginBottom: 10}}
      />
      {{
        receivables: <Receivables year={year.value} month={month.value}/>,
        cash: <Cash year={year.value} month={month.value}/>,
        bank_accounts: <BankAccounts/>,
        goals: <Goals year={year.value} month={month.value}/>,
        payables: <Payables year={year.value} month={month.value}/>
      }[view]}
    </Container>
  )
}
